import React from "react";
import { Container, Nav, Navbar, Button } from "react-bootstrap";
import "./Header.css";
import NavbarTop from "../navtop/Navtop";

function Header() {
  return (
    <>
      <section className="header_holder">
        <NavbarTop />
        <Navbar expand="lg" className="mainHeader">
          <Container>
            <Navbar.Brand href="/">
              <img
                src="/assets/images/logo/logo.png"
                alt="RioRelax"
                className="header-logo"
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto header-links">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/about-us">About</Nav.Link>
                <Nav.Link href="/gallery">Gallery</Nav.Link>
                <Nav.Link href="/contact-us">Contact</Nav.Link>
              </Nav>

            </Navbar.Collapse>
          </Container>
        </Navbar>
      </section>
    </>
  );
}

export default Header;
